import React, { useState, useEffect } from "react";
import { Image, Button, Icon, Confirm, Table } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { ENV } from "../../../../utils";
import { Permission,  EnvironmentalObjetivesform} from "../../../../api";
import { useAuth } from "../../../../hooks";
//import { EnvironmentalObjetivesForm} from "../EnvironmentalObjetivesForms";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import {
  formatDateHourCompleted,
  formatDateView,
} from "../../../../utils/formatDate";
import "./EnvironmentalObjetivesFormItem.scss";
import { useLanguage } from "../../../../contexts";

const EnvironmentalObjetivesFormController = new EnvironmentalObjetivesform();
const permissionController = new Permission();

export function EnvironmentalObjetivesFormItem(props) {
  const { EnvironmentalObjetivesForm, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  const openUpdateSite = () => {
    setTitleModal(`${t("update")} ${t("EnvironmentalObjetives_form")}`);
    onOpenCloseModal();
  };

  const onDelete = async () => {
    try {
      //TODO: modificar por controlador correspondiente
      await EnvironmentalObjetivesFormController.deleteEnvironmentalObjetivesForm(
        accessToken,
        EnvironmentalObjetivesForm._id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Table.Row key={EnvironmentalObjetivesForm._id}>
        <Table.Cell>
          <Icon color={EnvironmentalObjetivesForm.active ? "green" : "red"} name="circle" />
        </Table.Cell>
        <Table.Cell>{formatDateView(EnvironmentalObjetivesForm.date)}</Table.Cell>
        <Table.Cell>
          {EnvironmentalObjetivesForm.creator_user
            ? EnvironmentalObjetivesForm.creator_user.lastname
              ? EnvironmentalObjetivesForm.creator_user.lastname +
                " " +
                EnvironmentalObjetivesForm.creator_user.firstname
              : EnvironmentalObjetivesForm.creator_user.email
            : null}
        </Table.Cell>
        <Table.Cell>
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionsByRole, role._id, "permissions", "edit") ? (
            <Button icon primary onClick={openUpdateSite}>
              <Icon name="pencil" />
            </Button>
          ) : null}
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(
            permissionsByRole,
            role._id,
            "permissions",
            "delete"
          ) ? (
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          ) : null}
        </Table.Cell>
      </Table.Row>
      {/* <Button icon as="a" href={siteForm.url} target="_blank">
            <Icon name="eye" />
          </Button>
          <Button icon primary onClick={openUpdateSite}>
            <Icon name="pencil" />
          </Button>
          <Button icon color="red" onClick={onOpenCloseConfirm}>
            <Icon name="trash" />
          </Button> */}

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size={"fullscreen"}
      >
        <EnvironmentalObjetivesForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          EnvironmentalObjetivesForm={EnvironmentalObjetivesForm}
        />
      </BasicModal>

      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        header={t("delete")}
        content={`${t("delete_EnvironmentalObjetives_form_with_date")} ${formatDateView(
          EnvironmentalObjetivesForm.date
        )}`}
        confirmButton={t("accept")}
        cancelButton={t("cancel")}
        size="mini"
      />
    </>
  );
}
